import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getMagnetismDictTreeApi
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    dictData: null, // 数据字典
}

/* 获取数据字典 */
export const getMagnetismDictDataAction = createAsyncThunk('MagnetismSlice/getMagnetismDictDataAction', async (dictType, thunkAPI) => {
    const MagnetismTypeDataDict = getMagnetismDictTreeApi(dictType[0])
    const MagnetismStatusDataDict = getMagnetismDictTreeApi(dictType[1])
    return Promise.all([MagnetismTypeDataDict, MagnetismStatusDataDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

export const MagnetismSlice = createSlice({
    name: 'MagnetismSlice',
    initialState,
    reducers: {

    },
    extraReducers: {
        /* 处理数据字典 */
        [getMagnetismDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        }
    },
})
